import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DiagnosticInput, DiagnosticJobResponse } from '../models/diagnostic.models';
import { StoreAuxService } from '../../services/storeAux/store-aux.service';

@Injectable()
export class DiagnosticService {
  private readonly basePath = '/brands/finances-trm/ads';

  constructor(private readonly http: HttpClient, private readonly storeAux: StoreAuxService) {}

  enqueue(input: DiagnosticInput): Observable<{ job_id: string }> {
    return this.http.post<{ job_id: string }>(
      this.storeAux.getCountry(`${this.basePath}/diagnose/async`, input.country),
      {
        campaign_id: input.campaignId,
        country: input.country.toLowerCase(),
        store_id: input.storeId,
        store_type: input.storeType,
        campaign_type: input.campaignType,
        keyword: input.keyword || null
      }
    );
  }

  getJob(jobId: string, country: string): Observable<DiagnosticJobResponse> {
    return this.http.get<DiagnosticJobResponse>(
      this.storeAux.getCountry(`${this.basePath}/diagnose/${jobId}`, country)
    );
  }
}
